import React from "react";
import "./feedback.css";

/**
 * Плейсхолдер загрузки. `variant`: "page" | "table" | "form" | "text".
 */
const Skeleton = ({variant = "text", rows = 5, className = ""}) => {
    if (variant === "page") {
        return (
            <div className={`ui-skeleton ui-skeleton--page ${className}`.trim()} aria-hidden="true">
                <div className="ui-skeleton__line ui-skeleton__line--title"/>
                <div className="ui-skeleton__line ui-skeleton__line--subtitle"/>
                <div className="ui-skeleton__card"/>
                <div className="ui-skeleton__card"/>
            </div>
        );
    }

    if (variant === "table") {
        return (
            <div className={`ui-skeleton ui-skeleton--table ${className}`.trim()} aria-hidden="true">
                <div className="ui-skeleton__toolbar"/>
                {Array.from({length: rows}).map((_, index) => (
                    <div key={index} className="ui-skeleton__row">
                        <div className="ui-skeleton__cell ui-skeleton__cell--sm"/>
                        <div className="ui-skeleton__cell"/>
                        <div className="ui-skeleton__cell ui-skeleton__cell--lg"/>
                        <div className="ui-skeleton__cell ui-skeleton__cell--md"/>
                    </div>
                ))}
            </div>
        );
    }

    if (variant === "form") {
        return (
            <div className={`ui-skeleton ui-skeleton--form ${className}`.trim()} aria-hidden="true">
                <div className="ui-skeleton__card"/>
                <div className="ui-skeleton__card"/>
            </div>
        );
    }

    return (
        <div className={`ui-skeleton ui-skeleton--text ${className}`.trim()} aria-hidden="true">
            {Array.from({length: rows}).map((_, index) => (
                <div
                    key={index}
                    className="ui-skeleton__line"
                    style={{width: `${Math.max(35, 100 - index * 12)}%`}}
                />
            ))}
        </div>
    );
};

export default Skeleton;
